import React from 'react';
import FormObjectsListItem from './FormObjectsListItem';

const FormObjectsListItems = ({
  activeIndex,
  canEdit,
  category,
  code,
  component,
  errors,
  fields,
  isEditing,
  item,
  showEdit,
  toolTip = 'top right',
  updateProperties,
}) => fields.map((field, index) => (
  <FormObjectsListItem
    index={activeIndex}
    canEdit={canEdit}
    category={category}
    code={code}
    component={component(field)}
    errors={errors}
    field={field}
    fieldCount={fields.length}
    fieldIndex={index}
    isEditing={isEditing}
    key={`form_object_form_input_${field.name}`}
    onChange={updateProperties}
    showEdit={showEdit}
    text={item[field.name]}
    toolTip={index === 0 ? toolTip : 'top right'}
  />
));

export default FormObjectsListItems;
